import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { Text } from 'foundations-components/components/Text';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { HR } from 'foundations-components/transitional/components/HR';
import { H4 } from 'foundations-components/transitional/components/H4';
import { MarkdownText } from 'academy-common-lib/features/practicalExercises/components/MarkdownText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PracticalExerciseInstructions = ({
  description = '',
  inProgress,
  isGraded,
  isManuallyApproved,
  isSimulation,
  name
}) => {
  return /*#__PURE__*/_jsxs(View, {
    marginBlock: "1000",
    minBlockSize: "300px",
    paddingInlineStart: "1000",
    children: [/*#__PURE__*/_jsx(H4, {
      children: name
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "250",
      marginBlockStart: "500",
      children: /*#__PURE__*/_jsx(Text, {
        as: "strong",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.instructions.title"
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "800",
      children: /*#__PURE__*/_jsx(MarkdownText, {
        text: description
      })
    }), /*#__PURE__*/_jsx(HR, {
      marginBlock: "500"
    }), /*#__PURE__*/_jsx(Text, {
      as: "strong",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.statusTitle.notStarted"
      })
    }), /*#__PURE__*/_jsxs(List, {
      paddingInlineStart: "0",
      styled: true,
      children: [/*#__PURE__*/_jsx(ListItem, {
        marginInlineStart: "400",
        children: inProgress ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.instructions.continue"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.instructions.start"
        })
      }), isSimulation && /*#__PURE__*/_jsx(ListItem, {
        marginInlineStart: "400",
        children: /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.simulation.playgroundWillOpen"
          }), /*#__PURE__*/_jsx("strong", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.practicalExercise.simulation.progressReset"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        marginInlineStart: "400",
        children: isManuallyApproved ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.instructions.submitManual"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.instructions.submitAutomatic"
        })
      })]
    }), isGraded && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HR, {
        marginBlock: "500"
      }), /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "250",
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.reminder.title"
          })
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.reminder.required"
      })]
    })]
  });
};
export default PracticalExerciseInstructions;